import { render, staticRenderFns } from "./ergitme.vue?vue&type=template&id=5bf1d6f4&scoped=true&"
import script from "./ergitme.vue?vue&type=script&lang=js&"
export * from "./ergitme.vue?vue&type=script&lang=js&"
import style0 from "./ergitme.vue?vue&type=style&index=0&id=5bf1d6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf1d6f4",
  null
  
)

export default component.exports